﻿import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListMail extends GuiListGeneric {

    constructor() {
        super("Mail");

    }

    protected override clickRow() {
        this.log("clickRow");
    }
}
